import $, { ready } from 'jquery';
export default {
  init () {
    var $languageFilter =  $('#language-filter');
    var $languageButton =  $('.webinars-filter__button');
    var selectData =  '';
    var $url = '';
    var $parameters = null;
    function filter () {
      // set filter query, if ? already in url use &
      if (window.location.href.indexOf('?') != -1) {
        var url = window.location.href+`&language[]=${selectData}`;
      }
      // else use ?
      else {
        var url = window.location.href+`?language[]=${selectData}`;
      }
      window.location = url;
    }

    function removeFilter () {
      // remove filter under window reload ->
      $url = window.location.search;
      $parameters = $url.split(/\?|&/);
      var $filter = selectData;
      var $itemtoRemove = [];
      // if filter query already exists, 
      $parameters.forEach((element, i) => {
        if (element.indexOf($filter) != '-1') {
          $itemtoRemove.push(i);
        }
      });
      // remove from query url.
      $itemtoRemove.reverse().forEach(($element) => {
        if ($element >= 0) {
          $parameters.splice($element, 1);
          var $newUrl = $parameters.join('&');
          window.location = '?' + $newUrl;
        }
      })
    }

    function scrollToWebinars () {
        // Handler for .ready() called.
        $('.webinar-row')[0].scrollIntoView({
          behavior: "smooth", // or "auto" or "instant"
          block: "center", // or "end"
        });    
    }

    $languageFilter.on('change', function () {
      selectData = $(this).val();
      // remove all filters and set selected filter since this is a select element ( can filter by only one language)
      if (selectData === 'all') {
        window.location = window.location.pathname;
      }
      else {
        window.location = window.location.pathname+`?language[]=${selectData}`;
      }
    })

    $languageButton.on('click touchend', function () {
      selectData = $(this).val();
      // filter by multiple languages
      filter () 
      $(this).addClass('active');
      // if filter query already exists, remove from query url.
      removeFilter ();
    })

    $.when( ready ).then(function() {
      // Document is ready.
      if (window.location.href.indexOf('?') != -1 && $('.webinar-row')[0]) {
        scrollToWebinars ()
      }
    });

    function submitform()
    {
        document.getElementById("timeFormatSelectForm").submit()
    }
    $('#timeFormatSelectForm').on('change', function () {
      submitform()
    });
    

  }
}